/**
 * Delivery-cockpit tabs on /project-operations (wedge IA).
 */
export const PROJECT_OPS_TAB = {
    PORTFOLIO: 0,
    CONTROL_CENTER: 1,
    STAFFING: 2,
    TASKS: 3,
    GANTT: 4,
};

export const PROJECT_OPS_TAB_PARAM = {
    [PROJECT_OPS_TAB.PORTFOLIO]: 'portfolio',
    [PROJECT_OPS_TAB.CONTROL_CENTER]: 'control',
    [PROJECT_OPS_TAB.STAFFING]: 'staffing',
    [PROJECT_OPS_TAB.TASKS]: 'tasks',
    [PROJECT_OPS_TAB.GANTT]: 'gantt',
};

/** @param {string|null} tabParam */
export const projectOpsTabIndexFromParam = (tabParam) => {
    if (!tabParam) {
        return PROJECT_OPS_TAB.PORTFOLIO;
    }
    const entry = Object.entries(PROJECT_OPS_TAB_PARAM).find(([, value]) => value === tabParam);
    return entry ? Number(entry[0]) : PROJECT_OPS_TAB.PORTFOLIO;
};

/**
 * @param {number} projectId
 * @param {'control'|'staffing'} tabParam
 * @param {{ section?: string, startDate?: string, endDate?: string,
 *   periodMode?: string }} [options]
 */
export const buildProjectOpsWedgeUrl = (projectId, tabParam = 'control', options = {}) => {
    const params = new URLSearchParams({
        tab: tabParam,
        project: String(projectId),
    });
    if (options.section) {
        params.set('section', options.section);
    }
    if (options.startDate) {
        params.set('start_date', options.startDate);
    }
    if (options.endDate) {
        params.set('end_date', options.endDate);
    }
    // Carry the shared reporting timeline across tab deep-links so panels do not
    // silently fall back to a different default window.
    if (options.periodMode) {
        params.set('period_mode', options.periodMode);
    }
    return `/project-operations?${params.toString()}`;
};

/**
 * @param {number|string} projectId
 */
export const buildInvoiceManagementCreateUrl = (projectId) => (
    `/invoice-management?project=${projectId}&action=create`
);

/**
 * Deep-link to Financial tab on project-management (change orders, subconsultants).
 *
 * @param {number|string} projectId
 * @param {'change_orders'|'subconsultants'} [section]
 */
export const buildProjectFinancialTabUrl = (projectId, section = null) => {
    const params = new URLSearchParams({ tab: 'financial' });
    if (section) {
        params.set('section', section);
    }
    return `/project-management/${projectId}?${params.toString()}`;
};
